import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import PopularArticles from '../containers/PopularArticles';
import PromptContainer from '../containers/PromptContainer';
import TopicList from '../containers/TopicList';
import ChatBot from '../../contactUs/components/ChatBot';
import AuthPromptModal from '../containers/AuthPromptModal';

import { loadModalContainer } from '../../contactUs/actions/action-login-modal';
import { chatBotClickedAction } from '../../contactUs/actions/action-chat-bot';
import { chatBotLoaded } from '../actions/action-chat-bot';
import Page from '../../lib/page';
import { trackPage } from '../../lib/analytics-helper';
import UrlResources from '../constants/UrlResources';
import { chatBotMessageUsRefIdsMapping } from '../../common/commonConstants';
import { getModalChannelType } from '../../lib/globalHelper';
import { isAsyncUser } from '../../lib/asyncMessageHelper';

const isLoggedIn = Page.isLoggedIn();

/**
 * Changing HomePage from stateless component to get the chatBot Eligibility API response
 */

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.chatBotClicked = this.chatBotClicked.bind(this);
  }

  /**
   * Firing Paypal help guide L1 topic impression here
   * as the topic list component is rendering twice
   * @param prevProps
   */
  componentDidUpdate(prevProps) {
    const { isLoading, error, blacklistedMarketICFFlag } = this.props;
    // once the api has successful response and remote config set to true and experience is personal
    if ((prevProps.isLoading !== isLoading) && !isLoading && !error && !blacklistedMarketICFFlag
      && Page.getExpByUserType() === 'personal') {
      //  when paypal help guide L1 topic is enabled firing an impression event
      trackPage({ id: 'ICFL1Topic', link: `smarthelp-hcr-topic-list|${UrlResources.PAYPALGUIDE}` });
    }
  }

  chatBotClicked(isChatBotAsyncUser) {
    // Let's open up the login modal.
    if (isLoggedIn) {
      return null;
    }

    this.props.chatBotClickedAction();
    // Open messageus modal window if message us icon is enabled or async from chatbot in loggedout case
    return this.props.loadModalContainer(getModalChannelType(isChatBotAsyncUser));
  }

  chatBotLoad() {
    this.props.chatBotLoaded();
  }

  renderChatBotHome() {
    // postChatbot API eligible/in-eligible options to show/hide chatBot
    const {
      chatBotDisplay, chatBotTriggerMode, chatBotAsync, isInputFocused,
    } = this.props;

    // If chatbot is ineligible return null.
    if (!chatBotDisplay) {
      return null;
    }

    //  SearchBox is focused return true or false
    function isSearchInputBoxFocused() {
      if (Page.isMobileLayout()) {
        return isInputFocused;
      }
      return false;
    }

    // if chat bot trigger mode is open the chat window irrespective of whether chat/chat-bot click happened
    if (chatBotTriggerMode === 'OPEN') {
      return this.chatBotLoad();
    }

    const isChatBotAsyncUser = isAsyncUser(chatBotAsync);

    return (
      <ChatBot
        link="smarthelp-chat-bot-home"
        id="chatBotHome"
        topicRefId={chatBotMessageUsRefIdsMapping.GENPOOL_HOME_PAGE}
        chatBotClicked={this.chatBotClicked}
        display={chatBotDisplay}
        isChatBotAsyncUser={isChatBotAsyncUser}
        isSearchInputBoxFocused={isSearchInputBoxFocused}
      />
    );
  }

  render() {
    return (
      <div className="home-content-container">
        <PopularArticles />
        <div className="topic-list__grid">
          <TopicList />
        </div>
        <div className="prompt-container__grid">
          <PromptContainer />
        </div>
        {this.renderChatBotHome()}
        <AuthPromptModal />
      </div>
    );
  }
}

HomePage.propTypes = {
  chatBotDisplay: PropTypes.string.isRequired,
  chatBotTriggerMode: PropTypes.string.isRequired,
  loadModalContainer: PropTypes.func.isRequired,
  chatBotClickedAction: PropTypes.func,
  chatBotLoaded: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  chatBotAsync: PropTypes.bool.isRequired,
  isInputFocused: PropTypes.bool.isRequired,
  blacklistedMarketICFFlag: PropTypes.bool.isRequired,
};

HomePage.defaultProps = {
  chatBotClickedAction: () => {},
};

// Get the postChatBotEligibility redux data and Pass it as Props.
function mapStateToProps(state) {
  return {
    chatBotDisplay: state.postChatBotEligibility.chatBotDisplay,
    chatBotTriggerMode: state.postChatBotEligibility.chatBotTriggerMode,
    isLoading: state.topicList.isLoading,
    error: state.topicList.error,
    chatBotAsync: state.postChatBotEligibility.chatBotAsync,
    isInputFocused: state.contactReason.isInputFocused,
    blacklistedMarketICFFlag: state.topicList.blacklistedMarketICFFlag,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ loadModalContainer, chatBotClickedAction, chatBotLoaded }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
